import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Skeleton, Stack, Text } from '@bonusly/design-system';

export const LoadingAnnouncement: FC = () => {
	const { t } = useTranslation('announcements');
	return (
		<Stack data-testid="loading-announcement" spacing={5} p={5} overflow="scroll">
			<Stack spacing={2}>
				<Text fontWeight="medium" fontSize={50}>
					{t('modal.recipient_label')}
				</Text>
				<Skeleton height={10} width="100%" />
				<Text fontSize={50} color="text.softer">
					{t('modal.recipient_helper')}
				</Text>
			</Stack>

			<Stack spacing={2}>
				<Text fontWeight="medium" fontSize={50}>
					{t('modal.title_label')}
				</Text>
				<Skeleton height={10} width="100%" />
				<Text fontSize={50} color="text.softer">
					{t('modal.title_helper', { count: 0 })}
				</Text>
			</Stack>

			<Stack spacing={2}>
				<Text fontWeight="medium" fontSize={50}>
					{t('modal.description_label')}
				</Text>
				<Skeleton height={36} width="100%" />
				<Text fontSize={50} color="text.softer">
					{t('modal.description_helper', { count: 0 })}
				</Text>
			</Stack>

			<Stack spacing={2}>
				<Text fontWeight="medium" fontSize={50}>
					{t('modal.start_date_label')}
				</Text>
				<Skeleton height={10} width="100%" />
				<Text fontSize={50} color="text.softer">
					{t('modal.start_date_helper')}
				</Text>
			</Stack>

			<Stack spacing={2}>
				<Text fontWeight="medium" fontSize={50}>
					{t('modal.end_date_label')}
				</Text>
				<Skeleton height={10} width="100%" />
				<Text fontSize={50} color="text.softer">
					{t('modal.end_date_helper')}
				</Text>
			</Stack>

			<Stack spacing={2}>
				<Text fontWeight="medium" fontSize={50}>
					{t('modal.incentive_label')}
				</Text>
				<Skeleton height={10} width="100%" />
			</Stack>

			<Stack spacing={2}>
				<Text fontWeight="medium" fontSize={50}>
					{t('modal.image_upload_label')}
				</Text>
				<Skeleton height={20} width="100%" />
			</Stack>

			<Stack spacing={2}>
				<Text fontWeight="medium" fontSize={50}>
					{t('modal.notification_label')}
				</Text>
				<Skeleton height={5} width="30%" />
				<Skeleton height={5} width="35%" />
			</Stack>
		</Stack>
	);
};
